<script context="module" lang="ts">
	import type { ComponentType, SvelteComponentTyped } from 'svelte';
	import type { SVGAttributes } from 'svelte/elements';
	export type SVGComponent = ComponentType<
		SvelteComponentTyped<SVGAttributes<SVGSVGElement>, any, any>
	>;
</script>

<script lang="ts">
	import __ from '$lib/stores/TranslationStore';
	import HouseIcon from '$lib/assets/images/icons/home-outline.svg?component';
	import ChevronRight from '$lib/assets/images/icons/chevron-right.svg?component';
	import { htmlToText } from '$lib/utils/helpers/htmlToText';
	import { getStepper } from '../Stepper/stepper';
	import { crossfade, fade, fly, slide } from 'svelte/transition';

	export let header: string = '';
	export let caption: string = '';
	export let topHeader: boolean = false;
	export let inline: boolean = false;
	export let icon: SVGComponent = HouseIcon;

	const stepper = getStepper();

	$: previousData = $stepper.getPreviousStep();
</script>

<header
	class="grid p-5 lg:items-center lg:gap-[10px] {topHeader
		? 'lg:px-12 lg:py-5 xl:px-32'
		: 'cursor-pointer pb-5 pt-5 md:px-10'}"
>
	{#if !$stepper.showResult && previousData && !topHeader}
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<div
			transition:fly={{ x: -100, duration: 500 }}
			on:keydown={() => null}
			on:click={() => stepper.goPreviousStep()}
			class="col-[1/2] row-[1/2] flex select-none flex-col gap-y-2"
		>
			<div class="flex items-center gap-x-2 text-primary">
				<ChevronRight class="h-3 rotate-180 stroke-primary stroke-[6px]" />
				<h2 class="text-xs font-semibold lg:text-sm">{$__('Voltar')}</h2>
			</div>
			<div class="grid">
				{#key $stepper.currentStep}
					<h3
						class="col-[1/2] row-[1/2] text-xs text-caption lg:text-sm"
						transition:fly={{ x: -100, duration: 500 }}
					>
						{htmlToText($__(previousData?.title))}
					</h3>
				{/key}
			</div>
		</div>
	{:else}
		<div
			class="col-[1/2] row-[1/2] flex gap-[10px]"
			class:lg:hidden={!topHeader && $stepper.showResult}
		>
			<svelte:component
				this={icon}
				class="stroke-primary-light stroke-[3] {!topHeader ? 'hidden' : ''}"
			/>
			<div
				transition:fly={{ x: -100, duration: 500 }}
				class="col-[1/2] row-[1/2] flex {inline ? 'flex-row' : 'flex-col'} gap-2 tracking-0.14"
				class:lg:hidden={!topHeader}
			>
				<h1 class="text-sm font-bold uppercase text-primary md:leading-none lg:text-primary-light">
					{header}
				</h1>
				<h2 class="text-sm uppercase md:leading-none lg:text-white">{caption}</h2>
			</div>
		</div>
	{/if}
</header>
